 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + chunkId + ".chunkito.js?v=1784567276.588"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AccountVerification~DepositView":1,"AccountVerification":1,"DepositView":1,"BetSlipMobileWrapper":1,"BonusView":1,"ChangePassword":1,"ClerkDepositView~ClerkWagerView~games":1,"ClerkDepositView":1,"ClerkWagerView":1,"games~props":1,"games":1,"ClerkLoyaltyView":1,"ClerkPayout":1,"ClerkRegisterCustomerPayoutView":1,"ClerkWrapper":1,"ContactPreferences":1,"ContactUsView":1,"CreditCardView~ECheckView~MoneyGramView":1,"CreditCardView":1,"ECheckView":1,"MoneyGramView":1,"CryptoCurrencyPayoutView":1,"ECheckPayoutView~OnlineBankingPayoutView~WireTransferPayoutView":1,"ECheckPayoutView":1,"OnlineBankingPayoutView":1,"WireTransferPayoutView":1,"EwalletView":1,"ForgotPasswordView":1,"HelpView":1,"HistoryView":1,"LoginView":1,"MyAccountView":1,"Neteller":1,"OnlineBanking":1,"OxxoPayView":1,"PayoutView":1,"PendingPayoutsView":1,"PixView":1,"QUickBit":1,"ReferView":1,"RegisterView":1,"ResetPasswordView":1,"SelfExclusion":1,"SpeiView":1,"Static":1,"TermsOfUse":1,"ToditoPayoutView":1,"VcreditosPayoutView":1,"WireTransferView":1,"about":1,"casinogames":1,"chunk-0f2f63f3":1,"chunk-1b8c1b2c":1,"chunk-1c3cf6f2":1,"chunk-1dd61439":1,"chunk-1ee3a151":1,"chunk-29029eea":1,"casino":1,"chunk-6acc40db":1,"Start":1,"pageNotFound":1,"racing":1,"sports":1,"ClerkTicketTestView":1,"ClerkTicketView":1,"HorseTicketView":1,"chunk-25cd94b4":1,"chunk-31ec9a08":1,"chunk-42f8bcdf":1,"chunk-6f7247cb":1,"chunk-706881f5":1,"chunk-727db10f":1,"chunk-743ac936":1,"chunk-74905df6":1,"chunk-76d46544":1,"chunk-7edd2c89":1,"chunk-d8a2bdf2":1,"ewallet-declined":1,"ewallet-success":1,"false":1,"props":1,"online-banking-declined":1,"online-banking-success":1,"chunk-165e8c4b":1,"chunk-d262feac":1,"chunk-2490e67d":1,"chunk-46f3e15b":1,"chunk-669ebd52":1,"chunk-9a95fac2":1,"chunk-44a06428":1,"chunk-46fb9f9a":1,"chunk-4d684daa":1,"chunk-91aa4952":1,"chunk-b5b62498":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"AccountVerification~DepositView":"AccountVerification~DepositView","AccountVerification":"AccountVerification","DepositView":"DepositView","BetSlipMobileWrapper":"BetSlipMobileWrapper","BonusView":"BonusView","ChangePassword":"ChangePassword","ClerkDepositView~ClerkWagerView~games":"ClerkDepositView~ClerkWagerView~games","ClerkDepositView":"ClerkDepositView","ClerkWagerView":"ClerkWagerView","games~props":"games~props","games":"games","ClerkLoyaltyView":"ClerkLoyaltyView","ClerkPayout":"ClerkPayout","ClerkRegisterCustomerPayoutView":"ClerkRegisterCustomerPayoutView","ClerkWrapper":"ClerkWrapper","ContactPreferences":"ContactPreferences","ContactUsView~CreditCardView":"ContactUsView~CreditCardView","ContactUsView":"ContactUsView","CreditCardView~ECheckView~MoneyGramView":"CreditCardView~ECheckView~MoneyGramView","CreditCardView":"CreditCardView","ECheckView":"ECheckView","MoneyGramView":"MoneyGramView","CryptoCurrencyPayoutView":"CryptoCurrencyPayoutView","ECheckPayoutView~OnlineBankingPayoutView~WireTransferPayoutView":"ECheckPayoutView~OnlineBankingPayoutView~WireTransferPayoutView","ECheckPayoutView":"ECheckPayoutView","OnlineBankingPayoutView":"OnlineBankingPayoutView","WireTransferPayoutView":"WireTransferPayoutView","EwalletView":"EwalletView","ForgotPasswordView":"ForgotPasswordView","HelpView":"HelpView","HistoryView":"HistoryView","LoginView":"LoginView","MyAccountView":"MyAccountView","Neteller":"Neteller","OnlineBanking":"OnlineBanking","OxxoPayView":"OxxoPayView","PayoutView":"PayoutView","PendingPayoutsView":"PendingPayoutsView","PixView":"PixView","QUickBit":"QUickBit","ReferView":"ReferView","RegisterView":"RegisterView","ResetPasswordView":"ResetPasswordView","SatisfactionSurvey":"SatisfactionSurvey","SelfExclusion":"SelfExclusion","SpeiView":"SpeiView","Static":"Static","TermsOfUse":"TermsOfUse","ToditoPayoutView":"ToditoPayoutView","VcreditosPayoutView":"VcreditosPayoutView","WireTransferView":"WireTransferView","about":"about","casinogames":"casinogames","casino":"casino","Start":"Start","pageNotFound":"pageNotFound","racing":"racing","sports":"sports","ClerkTicketDepositView":"ClerkTicketDepositView","ClerkTicketTestView":"ClerkTicketTestView","ClerkTicketView":"ClerkTicketView","HorseTicketView":"HorseTicketView","ewallet-declined":"ewallet-declined","ewallet-success":"ewallet-success","false":"false","props":"props","online-banking-declined":"online-banking-declined","online-banking-success":"online-banking-success"}[chunkId]||chunkId) + ".css?v=1784567276.588";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
